import { MarketingPreferences } from 'components/hook-page/user-details-hookpages/marketing-preferences-hookpage/MarketingPreferences';
import React from 'react';

export const MarketingPreferencesPage: React.FC = () => {
    return <MarketingPreferences />;
};
